<template>
    <div>
        <div class="kpi-container">
            <KPIItem title="Total Interviews" icon="fas fa-list-ul" :value="total"
                :percentage="(total / maxValue) * 100" color="#4CAF50" />
            <KPIItem title="Last 30 Days" icon="fas fa-calendar-alt" :value="recent"
                :percentage="(recent / total) * 100" color="#2196F3" />
            <KPIItem title="Active Interviews" icon="fas fa-play-circle" :value="active"
                :percentage="(active / total) * 100" color="#FF9800" />
        </div>
        <div class="kpi-container">
            <KPIHighlight :value="candidataCount" title="Total Candidates Participated" />
            <ProblemDifficultyKPI />
        </div>
    </div>
</template>

<script>
import KPIItem from './KPIItem.vue'
import KPIHighlight from './KPIHighlight.vue'
import ProblemDifficultyKPI from './ProblemDifficultyKPI.vue'
import { getIntDashboardCount } from "../../api/index";

export default {
    name: 'KPIStats',
    components: { KPIItem, KPIHighlight, ProblemDifficultyKPI },
    props: { },
    computed: {
        maxValue() {
            return Math.max(this.total, 1)
        }
    },
    data() {
    return this.initialState();
  },
  mounted() {
    this.getDashboardCountDetails();
  },
  methods: {
    initialState() {
      return {
        loading: false,
        total: 0,
        recent: 0,
        active: 0,
        candidataCount: 0,
      };
    },
    getDashboardCountDetails() {
      this.loading = true;
      getIntDashboardCount()
        .then((resp) => {
          const Data = resp.data.data[0];
          this.total=Data.TotalIntCount;
          this.recent=Data.TotalIntLast30Days;
          this.active=Data.TotalIntActiveCount;
          this.candidataCount=Data.TotalCandidateCount;
          this.loading = false;
        })
        .catch((err) => {
          console.log("Error", err?.response?.data);
          this.loading = false;
        });
    },
  },
}
</script>

<style scoped>
.kpi-container {
    display: flex;
    gap: 24px;
    flex-wrap: wrap;
    justify-content: space-between;
    padding-top: 1rem;
    padding-bottom: 1rem;
}
</style>